// External
import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';
import { UiList } from './ui-list.models';

@Directive({
    selector: 'ui-list, [ui-list]'
})

export class UiListDirective implements OnInit {

    // Higlights controls wheter or not the list higlights on hover
    @Input() highlights: boolean;

    // Orientation* (optional) controls the orientation of the list, horizontal/vertical, posible values: row, column
    // Default layout is column (if attribute is not specified). Scss treated values: 'row' and 'column'
    @Input() orientation: string;

    // Size control the size of the list. Posible values lg, sm
    // Default is md wich is auto implied (doesn't need to have it's size set, nor a scss class)
    @Input() size: string;

    // Accesibility role, default is list it can be menu, or navigation
    @Input() role: UiList.Role = UiList.Role.LIST;

    @Input() type: UiList.Type = UiList.Type.DEFAULT; // default / nav

    constructor(
        private readonly renderer: Renderer2, private readonly el: ElementRef
    ) {}

    ngOnInit() {
        this.renderer.addClass(this.el.nativeElement, 'flex-list');
        this.renderer.addClass(this.el.nativeElement, this.type);
        this.renderer.setAttribute(this.el.nativeElement, 'role', this.role);

        if (this.highlights) {
            this.renderer.addClass(this.el.nativeElement, 'highlights');
        }

        if (this.orientation) {
            this.renderer.addClass(this.el.nativeElement, this.orientation);
        }

        if (this.size) {
            this.renderer.addClass(this.el.nativeElement, 'list-' + this.size);
        }
    }

}
